export const FILTER_ARRIVALS = 'arrivals'
export const FILTER_DEPARTURES = 'departures'
export const FILTER_KINDS = 'kinds'
export const FILTER_PROPERTIES = 'properties'
export const FILTER_RESORTS = 'resorts'
